interface FilterChipsProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  allLabel?: string;
}

export default function FilterChips({
  label,
  options,
  value,
  onChange,
  allLabel = "全部",
}: FilterChipsProps) {
  const items = [allLabel, ...options];
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
      <span className="shrink-0 pt-1 text-xs font-medium text-foreground-500 sm:w-16 sm:text-sm">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {items.map((item) => {
          const isAll = item === allLabel;
          const selected = isAll ? value === "" : value === item;
          return (
            <button
              key={item}
              type="button"
              onClick={() => onChange(isAll ? "" : item)}
              className={[
                "rounded-full px-3 py-1 text-xs transition-colors whitespace-nowrap cursor-pointer md:text-sm",
                selected
                  ? "bg-primary-700 text-background-50"
                  : "border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-700",
              ].join(" ")}
            >
              {item}
            </button>
          );
        })}
      </div>
    </div>
  );
}